import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
	selector: 'app-notification-select-students-dialog',
	templateUrl: './notification-select-students-dialog.component.html',
	styleUrls: ['./notification-select-students-dialog.component.scss'],
})
export class NotificationSelectStudentsDialogComponent {
	constructor(public dialogRef: MatDialogRef<NotificationSelectStudentsDialogComponent>) {}

	close() {
		this.dialogRef.close();
	}

	choose(student) {
		this.dialogRef.close(student);
	}
}
